import { Currency } from '@ps/web-core-enums';
import type { TrackedTranslation } from '@ps/web-core-intl';
import React from 'react';
import { useIntl } from 'react-intl';

import type { StepKey } from '../../../types';
import { StepKeyValue } from '../../../types';
import { getPrizePoolLabel } from '../../../utils/prizePool';
import Tile from '../Tile';

import { TXTCLI_LoadingXX } from './Skeleton.messages.json';

interface SkeletonProps {
  bannerClassName: string;
  stepKey: StepKey;
  playButtonTranslation: TrackedTranslation;
}

const Skeleton: React.FC<SkeletonProps> = ({ bannerClassName, stepKey, playButtonTranslation }) => {
  const { formatMessage } = useIntl();

  return (
    <Tile
      prize="-"
      prizeLabel={getPrizePoolLabel(stepKey)}
      buyIn="-"
      stepNumber={StepKeyValue[stepKey]}
      currency={Currency.USDollar}
      enrolled="-"
      status={formatMessage(TXTCLI_LoadingXX)}
      stepKey={stepKey}
      onRegister={() => undefined}
      bannerClassName={bannerClassName}
      playButtonTranslation={playButtonTranslation}
      isPlayButtonDisabled
    />
  );
};

export default Skeleton;
